import { all, takeLatest } from 'redux-saga/effects';
import { fetchPromoStoreCoupons } from 'store/promoStoreCoupons/actions';
import fetchPromoStoreCouponsWorker from './worker.fetchPromoStoreCoupons';

function* promoStoreCouponsSaga() {
  yield all([takeLatest(fetchPromoStoreCoupons, fetchPromoStoreCouponsWorker)]);
}

export default promoStoreCouponsSaga;
